import { useEffect } from 'react';
import { touchActive } from '@/hooks/useMojeWyszukiwanie';
import { dzienWarszawa } from '@/lib/alertyMieszkan';

/**
 * AKTYWNOŚĆ = ZALOGOWANA WIZYTA (docs/AlertEmails.md §4; build plan C8, PreLaunchChecklist 5.13).
 * Bez tego `last_active_at` stałby w miejscu i reguła 15 dni wyłączyłaby e-maile każdemu najemcy
 * 15 dni po włączeniu. Stempel idzie raz na dzień kalendarzowy (czas warszawski) na konto: dzień
 * zapamiętuje przeglądarka, więc kolejne wejścia tego dnia nie wołają bazy. Reguła liczy dni, więc
 * dokładniejszy stempel niczego by nie zmienił.
 *
 * ZAPYTANIA `KLUCZ_MOJEGO_WYSZUKIWANIA` NIE DOTYKA (poprawka po E2E na stage, 16.10). Stempel
 * idzie przy logowaniu, czyli zanim onboarding zapisze cenę i dzielnice; wiersz z jego odpowiedzi
 * włożony do pamięci podręcznej był więc przestarzały. Wyszukiwarka czyta to zapytanie z
 * `refetchOnMount: 'always'`, ale do czasu odświeżenia dostaje to, co w pamięci, i podstawia z
 * tego zbiór RAZ (`useStanWyszukiwania`) — najemca lądował bez ceny, a „Zapisz” było szare.
 * `last_active_at` czyta tylko baza (reguła 15 dni), więc ekranowi nic nie trzeba odświeżać.
 */

const KLUCZ = (uid: string) => `fh_aktywnosc_${uid}`;

/** Czy stemplować: nie, gdy dziś (Warszawa) już się udało. */
export function stempelNalezny(zapamietany: string | null, dzis: string): boolean {
  return zapamietany !== dzis;
}

/**
 * Konto bez zbioru (właściciel, agent, gwarant) dostaje od RPC „tenants only” — to też odpowiedź na
 * dziś. „access denied” (sesja bez wiersza users, w trakcie rejestracji) — spróbujemy przy następnym
 * wejściu.
 */
export function zapamietacPoBledzie(e: unknown): boolean {
  return /tenants only/.test(String((e as { message?: string })?.message ?? ''));
}

export function useStempelAktywnosci(uid: string | null | undefined): void {
  useEffect(() => {
    if (!uid) return;
    const dzis = dzienWarszawa(new Date());
    let zapamietany: string | null = null;
    try { zapamietany = localStorage.getItem(KLUCZ(uid)); } catch { /* bez pamięci: stempel przy każdym wejściu */ }
    if (!stempelNalezny(zapamietany, dzis)) return;
    const zapamietaj = () => { try { localStorage.setItem(KLUCZ(uid), dzis); } catch { /* jw. */ } };
    touchActive().then(zapamietaj, (e) => { if (zapamietacPoBledzie(e)) zapamietaj(); });
  }, [uid]);
}

/** Montowane raz w `App`. */
export function StempelAktywnosci({ uid }: { uid: string | null | undefined }) {
  useStempelAktywnosci(uid);
  return null;
}
